import { default as VehicleInfo } from './VehicleInfo'
import { default as Map } from './Map'

const Fleet = {
    Map,
    VehicleInfo
}

export default Fleet